/** The guest booking page. Some values contain trusted inline <strong> markup. */
export const enWidget = {
  'w.document_title': 'Reserve a table at {restaurant}',
  'w.reserve': 'Reserve a table',
  'w.no_restaurant': 'No restaurant is configured.',
  'w.code_not_found': 'We could not find that confirmation code.',
  'w.taken': 'Sorry, that time was just taken.',
  'w.offer_stale': 'That time is out of date. Searching again…',
  'w.hold_expired': 'Your hold expired. Please choose a time again.',
  'w.hold_expired_confirm': 'Your hold expired before you confirmed. Please choose a time again.',
  'w.call_for_party': 'Online booking for this party size is not available right now. Please call the restaurant.',
  'w.card_load_failed': 'Could not load the card form. Check your connection and try again.',
  'w.card_not_ready': 'The card form is not ready yet. Please wait a moment and try again.',
  'w.card_failed': 'Your card could not be verified.',
  'w.cancel_confirm': 'Cancel this reservation?',
  'w.cancel_fee': 'Per the cancellation policy, a fee may apply.',
  'w.online_off': 'Online reservations are not available. Please call the restaurant.',
  'w.online_off_waitlist':
    'Online reservations are not available; please join the waitlist at the restaurant, or call us.',
  'w.find_aria': 'Find a table',
  'w.date': 'Date',
  'w.time': 'Time',
  'w.party_size': 'Party size',
  'w.find': 'Find a table',
  'w.searching': 'Searching…',
  'w.nearby': 'Nearby times',
  'w.available_times': 'Available times',
  'w.day_aria': 'Day',
  'w.times_one': '{n} time',
  'w.times_other': '{n} times',
  'w.none': 'none',
  'w.no_tables': 'No tables for {party} on {date}',
  'w.try_other_day': 'Try another day above.',
  'w.card_required': 'card required',
  'w.unavailable': 'unavailable',
  'w.pay.legend': 'Payment',
  'w.pay.deposit': 'A deposit of <strong>{amount}</strong> is taken now and refunded if you cancel in time.',
  'w.pay.card':
    'We save your card to secure this booking. <strong>Nothing is charged</strong> unless the cancellation policy applies (up to {amount}).',
  'w.pay.test': 'Test mode: no card is needed and no money moves.',
  'w.pay.card_aria': 'Card details',
  'w.held_for': 'Held for {timer}',
  'w.table_for': 'Table for {n}',
  'w.change_time': 'Change time',
  'w.more_time': 'Need more time?',
  'w.policy.title': 'Cancellation policy',
  'w.policy.deposit': 'Deposit',
  'w.policy.card': 'Card hold',
  'w.policy.per_guest': 'per guest',
  'w.policy.flat': 'flat',
  'w.policy.detail': '{kind}: {amount} {per}; free cancellation up to {hours} hours before.',
  'w.seating': 'Seating',
  'w.first_name': 'First name',
  'w.last_name': 'Last name',
  'w.email': 'Email',
  'w.phone': 'Mobile',
  'w.occasion': 'Occasion (optional)',
  'w.request': 'Special request (optional)',
  'w.sms': 'Text me updates about this reservation',
  'w.marketing': 'Send me news and offers by email',
  'w.confirming': 'Confirming…',
  'w.confirm': 'Confirm reservation',
  'w.pay_confirm': 'Pay {amount} and confirm',
  'w.booked': 'You’re booked',
  'w.cancelled': 'Reservation cancelled',
  'w.code': 'Confirmation code',
  'w.row.restaurant': 'Restaurant',
  'w.row.when': 'When',
  'w.row.party': 'Party',
  'w.row.name': 'Name',
  'w.row.status': 'Status',
  'w.cancel': 'Cancel reservation',
  'w.new': 'Make another reservation',
  'w.menus': 'Menus',
  'w.menu.show': 'View menus',
  'w.menu.hide': 'Hide menus',
  'w.menu.price': '{price}',
  'w.event.title': 'Private events',
  'w.event.intro': 'Planning a celebration or a company dinner? Send us a request and we will come back with an offer.',
  'w.event.open': 'Request an event',
  'w.event.room': 'Room',
  'w.event.any': 'No preference',
  'w.event.guests': 'Guests',
  'w.event.date': 'Date',
  'w.event.from': 'From',
  'w.event.to': 'Until',
  'w.event.name': 'Your name',
  'w.event.company': 'Company (optional)',
  'w.event.email': 'Email',
  'w.event.phone': 'Phone (optional)',
  'w.event.notes': 'Tell us about the occasion',
  'w.event.send': 'Send request',
  'w.event.thanks': 'Thank you. We have your request and will get back to you by email.',
  'w.alert.title': 'Notify me',
  'w.alert.intro': 'Nothing free? Leave your email and we will tell you if a table opens up on this day.',
  'w.alert.from': 'From',
  'w.alert.to': 'Until',
  'w.alert.send': 'Tell me when a table opens',
  'w.alert.thanks': 'Done. We will email you when a table becomes available.',
  'w.code.link': 'I have an access code',
  'w.code.label': 'Access code',
  'w.code.apply': 'Apply',
  'w.code.bad': 'That code is not valid.',
  'w.member': 'Members only',
  'w.member_error': 'This offer is for invited guests. Please use the email address your restaurant knows.',
  'w.event.taken': 'already booked then',
  'w.contact': 'Contact',
  'w.about': 'About the restaurant',
  'w.terms': 'I accept the terms and conditions.',
  'w.exp.title': 'Special offers',
  'w.exp.any': 'A table, no special offer',
  'w.exp.price': '{price} per guest',
  'w.wl.title': 'Waitlist',
  'w.wl.join': 'Join the waitlist',
  'w.wl.offer': 'Nothing is free at these times. You can join the waitlist and we will text you when a table is ready.',
  'w.wl.closed': 'The waitlist is not open right now.',
  'w.wl.name': 'Your name',
  'w.wl.sms': 'Text me when my table is ready',
  'w.wl.submit': 'Add me to the waitlist',
  'w.wl.waiting': 'You are on the waitlist',
  'w.wl.ready': 'Your table is ready. Please come to the host stand.',
  'w.wl.done': 'Thank you. You are no longer on the waitlist.',
  'w.wl.quote': 'Estimated wait',
  'w.wl.waited': 'Waiting so far',
  'w.wl.ahead': 'Parties ahead of you',
  'w.wl.minutes': '{n} min',
  'w.wl.keep_open': 'Keep this page open. It updates by itself.',
} as const;
